import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './Section.css';
import './Invitation.css';
import { CEREMONY_DATE, RECEPTION_DATE } from '../constants';
import { viewInvitationClicked } from '../actions/invitation';
import traditionalInvitation from '../assets/traditional_invitation.png';
import codeInvitation from '../assets/code_invitation.png';

const mapStateToProps = state => ({
  invitee: state.invitee,
  weddingDate: state.dates.weddingDate,
  preceptionDate: state.dates.preceptionDate,
  invitationVisible: state.invitation.invitationVisible,
  invitationStyle: state.invitee.invitation_style,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ viewInvitationClicked }, dispatch);
}

const EventMap = ({ address, mapLink }) => {
  const key = process.env.REACT_APP_GMAPS_KEY;
  const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
  const url = `${baseUrl}?center=${address}&zoom=10&size=500x600&key=${key}&markers=size:mid%7Ccolor:0xff0000%7Clabel:%7C${address}`;
  const tooLong = `If this doesn't load it's because it costs money per view and I am trying to save money`;
  return (
    <a
      className="event-map"
      href={mapLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      {/* {tooLong} */}
      <img src={url} alt="map to event" placeholder={tooLong} />
    </a>
  );
};

// const Canada = () => (
//   <div className="event-details">
//     <h2>Parksville Preception</h2>
//     <p>{PRECEPTION_DATE.format('MMMM Do, YYYY')}</p>
//     <p>Pacific Shores Resort and Spa</p>
//     <p>Nanoose Bay, BC</p>
//   </div>
// );

const Reception = () => (
  <div className="event-details">
    <h2>Reception</h2>
    <p>{RECEPTION_DATE.format('HH:mm MMMM Do')}</p>
    <p>230 Elm Street</p>
    <p>Southampton, NY</p>
  </div>
);

const Ceremony = ({ onClickFunc }) => (
  <div className="event-details">
    <h2>
      <a
        href="https://www.youtube.com/watch?v=AM3mcTS8NMo"
        target="_blank"
        rel="noopener noreferrer"
      >
        Ceremony
      </a>
    </h2>
    <p>{CEREMONY_DATE.format('HH:mm MMMM Do')}</p>
    <p>1659 Meadow Lane</p>
    <p>Southampton, NY</p>
    <p>Look for parking attendant</p>
    <p onClick={onClickFunc} className="pointer view-invitation">
      View Invitation
    </p>
  </div>
);

const Main = ({ props, sectionId }) => {
  const { events = {} } = props.invitee;
  const visible = props.invitationVisible;

  return (
    <section id={sectionId}>
      <div
        className={`invitation ${visible ? 'invitation-visible' : ''} ${
          events.ca && events.ny ? 'both-events' : 'both-events'
        }`}
      >
        <h1>Time + Location</h1>
        {/* {events.ca && (
          <EventMap
            address="Pacific Shores Resort and Spa"
            mapLink="https://bit.ly/2UTFiXZ"
          />
        )} */}
        {events.ny && (
          <EventMap
            address="1659 Meadow Lane, Southampton, NY, USA"
            mapLink="https://bit.ly/2Z2nIPt"
          />
        )}
        {events.ny && (
          <Ceremony
            date={CEREMONY_DATE}
            onClickFunc={props.viewInvitationClicked}
          />
        )}
        {events.ny && (
          <EventMap
            address="230 Elm Street, Southampton, NY, USA"
            mapLink="https://bit.ly/2rpwuYM"
          />
        )}
        {events.ny && <Reception date={RECEPTION_DATE} />}
        <div className="full-invitation" onClick={props.viewInvitationClicked}>
          <img
            src={
              props.invitationStyle === 'modern'
                ? codeInvitation
                : traditionalInvitation
            }
            alt="You're invited!"
            height="810"
            width="570"
          />
          <p className="invitation-back pointer">back</p>
        </div>
      </div>
    </section>
  );
};

class Invitation extends Component {
  componentWillMount() {
    this.sectionId = `section-${this.props.section}`;
  }

  render() {
    return <Main props={this.props} sectionId={this.sectionId} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Invitation);



// WEBPACK FOOTER //
// ./src/components/Invitation.js